import { DiContainer } from '@jack-henry/frontend-utils/di';
import { SecurityMessage } from '@treasury/domain/channel/mappings/security';
import { IdentityDialogOptions, IdentityDialogResult, TmApiError } from '@treasury/domain/shared';
import { TmDialogService } from '@treasury/presentation/services/dialog';
import { html } from 'lit';
import { defaultDialogOptions, mapExitReason } from './identity-verification-dialog.helpers';

export async function openIdentityDialog<T = object>(
    securityMessage: SecurityMessage,
    options: Partial<IdentityDialogOptions> = {}
): Promise<IdentityDialogResult<T>> {
    const { forLogin, withoutUserInteraction, otpRequestFn, disableClose } = {
        ...defaultDialogOptions,
        ...options,
    };
    const diContainer = await DiContainer.getInstance();
    const dialogService = diContainer.get(TmDialogService);
    const handle = dialogService.open<IdentityDialogResult<T>>(
        html`<identity-verification-dialog
            .securityMessage=${securityMessage}
            .disableClose=${disableClose}
            .forLogin=${forLogin}
            .withoutUserInteraction=${withoutUserInteraction}
            .otpRequestFn=${otpRequestFn}
        ></identity-verification-dialog>`,
        'Identity Verification',
        {
            // component renders its own buttons
            showButtons: false,
            preventClose: true,
        }
    );

    const { reason, data } = await handle;

    if (!data) {
        throw new Error('Identity dialog exited with no data.');
    }

    if (data instanceof TmApiError) {
        throw data;
    }

    const { response, message } = data;
    return {
        reason: mapExitReason(reason),
        response,
        message,
    };
}
